module.exports = __webpack_public_path__ + "static/images/skin-bg.0468a43.png";